import { twJoin } from 'tailwind-merge';

import type { Props as BaseButtonProps } from './BaseButton';
import { BaseButton } from './BaseButton';

export const GradientButton = ({ className, ...rest }: BaseButtonProps) => {
  return (
    <BaseButton
      {...rest}
      className={twJoin(
        'text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
        className,
      )}
    />
  );
};
